module.exports = __webpack_public_path__ + "static/media/Payroll4.3951d30a.svg";